import { useState, useRef, useEffect } from 'react'
import { Outlet, Link, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import logo from '../assets/logosmall.png'
import './Layout.css'

function Layout() {
  const { user, logout, sessionWarning, dismissSessionWarning } = useAuth()
  const [showUserMenu, setShowUserMenu] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const menuRef = useRef(null)
  const navigate = useNavigate()

  // Get user initials for avatar
  const getInitials = () => {
    if (!user?.email) return 'U'
    return user.email.substring(0, 2).toUpperCase()
  }

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="layout">
      {/* Session Warning Banner */}
      {sessionWarning && (
        <div className="session-warning">
          <span>Your session will expire soon. Please save your work.</span>
          <button onClick={dismissSessionWarning}>&times;</button>
        </div>
      )}

      <header className="header">
        <nav className="navbar">
          <div className="nav-brand">
            <Link to="/dashboard">
              <img src={logo} alt="Frate.Cloud" className="nav-logo" />
            </Link>
            <span className="nav-ai-badge"><span className="nav-ai-icon">✨</span> AI-Powered</span>
          </div>
          <button
            className="hamburger"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
          </button>
          <ul className={`nav-links ${mobileMenuOpen ? 'nav-links--open' : ''}`}>
            <li><NavLink to="/dashboard" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Dashboard</NavLink></li>
            <li><NavLink to="/rfqs" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Requests</NavLink></li>
            <li><NavLink to="/carriers" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Carriers</NavLink></li>
          </ul>
          <div className="nav-actions">
            <div className="user-menu" ref={menuRef}>
              <button
                className="user-avatar"
                onClick={() => setShowUserMenu(!showUserMenu)}
                aria-label="User menu"
              >
                {getInitials()}
              </button>
              {showUserMenu && (
                <div className="user-dropdown">
                  <div className="user-info">
                    <span className="user-email">{user?.email}</span>
                    {user?.role && (
                      <span className="user-role">{user.role}</span>
                    )}
                  </div>
                  <hr />
                  <button className="dropdown-btn">Help</button>
                  <button onClick={handleLogout} className="logout-btn">
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </nav>
      </header>

      <main className="main-content">
        <Outlet />
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>FreightForward</h4>
            <p>Your trusted partner in global logistics and freight forwarding solutions.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#docs">Documentation</a></li>
              <li><a href="#support">Support Center</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: support@freightforward.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 FreightForward. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}

export default Layout
